import styled from 'styled-components';

export const ChipsWrapper = styled.div`
  padding: 10px 30px 30px 30px;
`;

export const OptionItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  padding: 12px;
  background-color: ${({ theme }) => theme.white.a10};
  box-shadow: ${({ theme }) => theme.misc.tileShadow};
  font-size: 1.333rem;
  letter-spacing: 0.3px;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a6};
  align-items: center;

  &.is-open {
    box-shadow: none;
    border-radius: 0 !important;
  }
`;

export const Caret = styled.div`
  padding-right: 10px;
  color: ${({ theme }) => theme.black.a3};

  svg {
    stroke-width: 1.5px;
  }
`;

export const FormContainer = styled.div`
  position: relative;
`;

export const DelContainer = styled.div`
  position: absolute;
  left: 30px;
  bottom: 20px;
`;

export const VisibilityDescription = styled.span`
  margin-left: 5px;
`;

export const DescriptionContainer = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  margin-left: 30px;
`;
